// extracted by mini-css-extract-plugin
module.exports = {"block":"UserMenu_block__7G9Ot","button":"UserMenu_button__LJZSE","slide-up":"UserMenu_slide-up__FV0IX"};